/**
 * Validated payment method status value object
 */
export type PaymentMethodStatus = Readonly<string>;

/**
 * Creates a validated PaymentMethodStatus value object.
 *
 * @param raw - Raw status string
 * @returns Validated PaymentMethodStatus
 * @throws Error if status is empty
 */
export const createPaymentMethodStatus = (raw: string): PaymentMethodStatus => {
  if (!raw?.trim()) {
    throw new Error('Payment method status is required');
  }
  return raw as PaymentMethodStatus;
};
